import React from "react";
import "./ApplicantSummarySidebar.scss";
import { ValidationSummary } from "./ValidationSummary";
import { useFinancialApplicationForm } from "@/hooks/useFinancialApplicationForm";

interface ApplicantSummarySidebarProps {
  financialApplicationId: string;
}

export const ApplicantSummarySidebar: React.FC<ApplicantSummarySidebarProps> = ({ financialApplicationId }) => {
  
  const { formValue } = useFinancialApplicationForm(financialApplicationId);

  return (
    <div className="applicant-summary-sidebar">
      <div className="applicant-summary-sidebar__content">
        {/* Validation Summary Component */}
        <ValidationSummary 
          validationState={formValue?.validationState}
        />
      </div>
    </div>
  );
};
